import React from 'react';
import { Link } from 'react-router-dom';

function Library() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Global Private Healthcare Library: Surgical Handbooks & Documentation Guides
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', margin: 0 }}>
          Welcome to the open-access research index compiled by <strong>Medical Trip World</strong>. This specialized library functions as an independent directory reference, offering medical tourism cost breakdowns, treatment process maps, and procedural guides for international traveling families.
        </p>
      </header>

      {/* CORE MANUALS LINKS - OPTIMIZED BREAKPOINTS */}
      <section style={{ marginTop: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #ff9f1c', paddingBottom: '8px', fontSize: 'clamp(1.25rem, 5vw, 1.5rem)' }}>
          Search-Indexed Clinical & Logistics Manuals
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', 
          gap: '20px', 
          marginTop: '20px' 
        }}>
          
          <div style={{ border: '1px solid #e2e8f0', padding: '20px', borderRadius: '6px', background: '#f8fafc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
            <div>
              <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.2rem', lineHeight: '1.4' }}>📘 Coronary Angioplasty & Bypass Research Guide</h4>
              <p style={{ fontSize: '0.95rem', color: '#444', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                Understand standard terminology regarding drug-eluting stent configurations, multi-vessel private bypass surgery parameters, and diagnostic screening tools before coordinating direct hospital communications.
              </p>
            </div>
            <Link to="/cardiology" style={{ color: '#28a745', fontWeight: 'bold', textDecoration: 'none', fontSize: '0.9rem', display: 'inline-flex', alignItems: 'center', minHeight: '44px' }}>Access Cardiology Library Index →</Link>
          </div>

          <div style={{ border: '1px solid #e2e8f0', padding: '20px', borderRadius: '6px', background: '#f8fafc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
            <div>
              <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.2rem', lineHeight: '1.4' }}>📙 Indian Medical Visa Application Blueprint</h4>
              <p style={{ fontSize: '0.95rem', color: '#444', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                Step-by-step documentation guides for filing electronic medical visas online, managing mandatory FRRO digital stay registrations, and navigating local residency validation forms cleanly.
              </p>
            </div>
            <Link to="/guides" style={{ color: '#28a745', fontWeight: 'bold', textDecoration: 'none', fontSize: '0.9rem', display: 'inline-flex', alignItems: 'center', minHeight: '44px' }}>Access Visa Reference Manual →</Link>
          </div>

        </div>
      </section>

      {/* FOOTER DISCLAIMER BLOCK */}
      <footer style={{ marginTop: '40px', padding: 'clamp(15px, 4vw, 20px)', background: '#fafafa', borderTop: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.85rem', color: '#666', lineHeight: '1.6', boxSizing: 'border-box' }}>
        <strong>Educational Library Disclaimer:</strong> The information provided within this digital research portal is compiled entirely from open public sources and industry metrics for educational reference only. Medical Trip World does not issue surgical diagnostic papers, prescribe medications, employ clinical consultants, or maintain liability partnerships or exclusive contracts with any private corporate healthcare group.
      </footer>

    </article>
  );
}

export default Library;